"use client";

import React from "react";
import CalSchedular from "./CalSchedular";

export default function ScheduleClientPage() {
  return (
    <div className="flex flex-col w-full min-h-screen pt-22 md:pt-26 xl:pt-24 bg-[#F7F2FF] dark:bg-[#020409]">
      <div className="flex w-full flex-col items-center gap-6 p-4 px-5 md:px-[40px] xl:px-[100px] 3xl:px-[150] mx-auto">
        <h1
          className="font-alexandria text-[#DF26DF] text-center dark:text-[#FB42F8] font-bold text-2xl md:text-3xl xl:text-[35px] leading-none tracking-[.04em] uppercase"
          style={{ letterSpacing: "4%" }}
        >
          Book a Strategy Call
        </h1>
        <p className="font-manrope font-medium text-center text-[14px] sm:text-[14px] md:text-[14px] xl:text-[16px] leading-[28px] tracking-wide text-gray-700 dark:text-gray-300">
          Join us for a free strategy call and expert consultation to refine
          your idea, define your MVP scope, and align your product direction for
          a fast, efficient launch. During this session, we&apos;ll help you
          gain clarity, validate your assumptions, and map out the next steps
          for your journey.
        </p>
      </div>
      <CalSchedular />
    </div>
  );
}
